<script>
export default {
    props: {
        information_id: Number
    },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            expand: false,
            visible: false,
            visibleInformation: false,
            visibleAttachment: false,
            information: null,
            processing: false,
            items: {},
            filters: {
                q: null,
                page: 1
            }
        };
    },
    created() {
        this.items = this.getDefaultPagination();
        this.filters = _.merge(this.filters, this.$laravel.request);
        this.getItems();
    },
    computed: {
        activeModule() {
            return this.$laravel.active_module
        },
        roleAdmin() {
            let role = this.$laravel.roles[this.activeModule.module.identifier]

            role = typeof role === "string" ? role : role[0]

            return role == 'admin'
        },
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault();
            this.pushState(this.filters);
            this.getItems();
        },
        handleReset(e) {
            e.preventDefault();
            this.filters = {
                q: null,
                page: 1
            };
        },
        tableChanged(pagination) {
            this.filters.page = pagination.current;
            this.pushState(this.filters);
            this.getItems();
        },
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri("api.information.show", {
                    information: this.information_id
                }), {
                    params: this.filters,
                })
                .then(response => (this.items = response.data))
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        handleDelete(id) {
            this.processing = true;

            this.$http
                .delete(
                    this.routeUri("api.information.destroy", {
                        information: id
                    })
                )
                .then(response => this.handleSuccessResponse(response.data))
                .catch(error => this.handleResponseError(error.response.data))
                .finally(() => (this.processing = false));
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });

            this.getItems();
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        showModal(hash) {
            this.information = hash.toString()
            this.visible = true

        },
        showModalAnnounce(hash) {
            this.information = hash;
            this.visibleInformation = true;
        },
        showModalAttachment(hash) {
            this.information = hash.toString();
            this.visibleAttachment = true;
        },
        closeModal(isRefresh) {
            this.visible = false;
            this.visibleInformation = false;
            this.visibleAttachment = false;
            this.visibleAddInformation = false

            if (isRefresh == true) {
                this.getItems();
            }
        },
        download(url) {
            window.open(url, '_blank')
        },
        back() {
            window.location.href = this.routeUri('admin.classical.information')
        },
    },
    filters: {
        truncate: function (text, length, suffix) {
            if (text.length > length) {
                return text.substring(0, length) + suffix;
            } else {
                return text;
            }
        },
    }
};
</script>
<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Informasi Detail" @back="back">
            <br>
            <a-card type="inner" size="small" bordered>
                <a-row type="flex">
                    <a-col :span="24">
                        <a-descriptions bordered>
                            <a-descriptions-item label="Kategori">
                                <strong>{{ this.items.title }}</strong>
                            </a-descriptions-item>
                        </a-descriptions>
                    </a-col>
                </a-row>
            </a-card>
        </a-page-header>

        <a-row type="flex" style="margin-bottom: 12px">
            <a-col  style="padding-left: 12px" flex="1 1 200px"></a-col>
            <a-col flex="0 1 300px"><a-button v-if="roleAdmin" type="primary" icon="plus" block @click="showModal('')"> Tambah Informasi</a-button></a-col>
        </a-row>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :dataSource="items.informations"
                rowKey="id"
                :pagination="false"
                :loading="loading"
                @change="tableChanged"
                bordered>

                <a-table-column key="title" title="Judul" className="align-center text-small text-left">
                    <template slot-scope="record">
                        {{ record.title }}
                    </template>
                </a-table-column>

                <a-table-column key="description" title="Uraian" className="align-center text-small text-left">
                    <template slot-scope="record">
                        {{ record.description | truncate(20, '...')  }}
                    </template>
                </a-table-column>

                <a-table-column key="is_active" v-if="roleAdmin" title="Status" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <a-tag
                            :color="record.is_active == true ? 'green' : 'red'"
                        >
                            {{
                                record.is_active == true
                                    ? "active"
                                    : "not active"
                            }}
                        </a-tag>
                    </template>
                </a-table-column>

                <a-table-column key="is_dashboard" v-if="roleAdmin" title="Dashboard" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <a-tag
                            :color="record.is_dashboard == true ? 'green' : 'red'"
                        >
                            {{
                                record.is_dashboard == true
                                    ? "YES"
                                    : "NO"
                            }}
                        </a-tag>
                    </template>
                </a-table-column>

                <a-table-column key="attachment" v-if="roleAdmin" title="Lampiran" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <a-button type="link" size="small" @click="download(record.attachment)"
                            v-if="record.attachment != null">
                            <a-icon type="file-pdf" theme="twoTone" two-tone-color="#eb3437" /> Download
                        </a-button>
                        <a-tooltip title="Reupload lampiran">
                            <a-button type="dashed" icon="upload" size="small" @click="showModalAttachment(record.id)">
                            Reupload</a-button>
                        </a-tooltip>
                    </template>
                </a-table-column>

                <a-table-column key="updatedAt" title="Last Updated" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <template v-if="record.updated_at != null">
                            {{ moment(record.updated_at).format('DD-MM-YYYY HH:mm:ss') }}
                        </template>
                    </template>
                </a-table-column>

                <a-table-column key="action" title="Action" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <a-space>
                            <a-tooltip title="Edit Informasi">
                                <a-button
                                    size="small"
                                    type="primary"
                                    icon="edit"
                                    v-if="roleAdmin"
                                    @click="showModal(record.id)"
                                />
                            </a-tooltip>

                            <a-popconfirm
                                title="Anda yakin akan menghapus data ini?"
                                ok-text="Yes"
                                cancel-text="No"
                                @confirm="handleDelete(record.id)"
                            >
                                <a-button
                                    size="small"
                                    icon="delete"
                                    type="danger"
                                    v-if="roleAdmin"
                                    :loading="processing"
                                    :disabled="processing"
                                />
                            </a-popconfirm>

                            <a-tooltip title="Preview">
                                <a-button
                                    size="small"
                                    icon="eye"
                                    @click="showModalAnnounce(record.id)"
                                />
                            </a-tooltip>
                        </a-space>
                    </template>
                </a-table-column>
            </a-table>

            <a-modal
                :destroyOnClose="true"
                :footer="null"
                :visible="visible"
                :closable="false"
            >
                <classical-information-form
                    :information="this.information"
                    :parent_id="information_id"
                    @handleClose="closeModal"
                />
            </a-modal>

            <a-modal
                :destroyOnClose="true"
                :footer="null"
                :visible="visibleInformation"
                :closable="false"
            >
                <information
                    :information="this.information"
                    @handleClose="closeModal"
                />
            </a-modal>

            <a-modal
                :destroyOnClose="true"
                :footer="null"
                :visible="visibleAttachment"
                :closable="false"
            >
                <classical-information-upload
                    :information="this.information"
                    @handleClose="closeModal"
                />
            </a-modal>
        </a-card>
    </div>
</template>
